module.exports = __webpack_public_path__ + "img/PART-B-JAPAN.5803d52f.png";